import { Menu } from 'lucide-react';
import { ButtonIcon } from 'twyne-new.ui';

import { useAppLayoutContext } from '../app-layout/context';

export default function ButtonCollapse() {
  const { sidebarCollapse, setMenuCollapsed } = useAppLayoutContext()
  return <ButtonIcon onClick={() => setMenuCollapsed(!sidebarCollapse)}>
    <Menu />
  </ButtonIcon>
}
